(()=>{
  document.body.classList.add('hc-landing-active');

  const money=(cents,format)=>{
    if(window.Shopify&&Shopify.formatMoney){try{return Shopify.formatMoney(cents,format)}catch(e){}}
    return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format((cents||0)/100);
  };

  document.querySelectorAll('[data-hc-product-root]').forEach(root=>{
    const variantsScript=root.querySelector('[data-hc-variants]');
    if(!variantsScript) return;
    let variants=[];try{variants=JSON.parse(variantsScript.textContent)}catch(e){return}
    const form=root.querySelector('form[action*="/cart/add"]');
    if(!form) return;

    const hiddenId=form.querySelector('input[name="id"]');
    const priceEl=root.querySelector('[data-hc-price]');
    const compareEl=root.querySelector('[data-hc-compare]');
    const saveEl=root.querySelector('[data-hc-save]');
    const stockEl=root.querySelector('[data-hc-stock]');
    const buttonPrice=root.querySelector('[data-hc-button-price]');
    const addBtn=form.querySelector('[type="submit"]');
    const sticky=root.querySelector(`[data-hc-sticky="${root.dataset.sectionId}"]`);
    const stickyId=root.querySelector(`[data-hc-sticky-id="${root.dataset.sectionId}"]`);
    const stickyPrice=root.querySelector('[data-hc-sticky-price]');
    const stickyBtn=sticky?sticky.querySelector('[data-hc-submit-main]'):null;
    const stage=root.querySelector('[data-hc-gallery-stage]');
    const slides=[...root.querySelectorAll('[data-hc-slide]')];
    const thumbs=[...root.querySelectorAll('[data-hc-thumb]')];
    const currentCounter=root.querySelector('[data-hc-gallery-current]');
    let scrollTimer=null;

    function isMobile(){return window.matchMedia('(max-width:749px)').matches}
    function selectedOptions(){
      return [...root.querySelectorAll('[data-hc-option-group]')].map(group=>{
        const checked=group.querySelector('input:checked');return checked?checked.value:null;
      });
    }
    function updateSelectedLabels(){
      root.querySelectorAll('[data-hc-option-group]').forEach(group=>{
        const checked=group.querySelector('input:checked');
        const target=group.querySelector('[data-hc-selected-text]');
        if(target&&checked) target.textContent=checked.value;
      });
    }
    function setActiveMedia(mediaId,index,scroll=true){
      if(!slides.length) return;
      let target=mediaId?slides.find(slide=>String(slide.dataset.mediaId)===String(mediaId)):null;
      if(!target&&index) target=slides.find(slide=>String(slide.dataset.index)===String(index));
      if(!target) target=slides[0];
      const targetIndex=target.dataset.index||'1';
      slides.forEach(slide=>slide.classList.toggle('is-active',slide===target));
      thumbs.forEach(thumb=>thumb.classList.toggle('is-active',String(thumb.dataset.index)===String(targetIndex)));
      if(currentCounter) currentCounter.textContent=targetIndex;
      const activeThumb=thumbs.find(thumb=>thumb.classList.contains('is-active'));
      if(activeThumb) activeThumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
      if(scroll&&isMobile()&&stage){
        stage.scrollTo({left:target.offsetLeft,behavior:'smooth'});
      }
    }
    function setUnavailable(){
      if(addBtn){addBtn.disabled=true;addBtn.dataset.hcUnavailable='true';const label=addBtn.querySelector('[data-label]');if(label)label.textContent='INDISPONÍVEL';}
      if(stickyBtn) stickyBtn.disabled=true;
      if(stockEl){stockEl.classList.add('is-unavailable');const span=stockEl.querySelector('span');if(span)span.textContent='Indisponível';}
    }
    function syncVariant(){
      updateSelectedLabels();
      const opts=selectedOptions();
      const variant=variants.find(v=>v.options.every((o,i)=>o===opts[i]));
      if(!variant){setUnavailable();return}
      hiddenId.value=variant.id;
      if(stickyId) stickyId.value=variant.id;
      const formatted=money(variant.price,root.dataset.moneyFormat);
      if(priceEl) priceEl.textContent=formatted;
      if(buttonPrice) buttonPrice.textContent=variant.available?formatted:'';
      if(stickyPrice) stickyPrice.textContent=formatted;
      if(compareEl){
        if(variant.compare_at_price&&variant.compare_at_price>variant.price){compareEl.textContent=money(variant.compare_at_price,root.dataset.moneyFormat);compareEl.hidden=false}else compareEl.hidden=true;
      }
      if(saveEl){
        if(variant.compare_at_price&&variant.compare_at_price>variant.price){const pct=Math.round((1-variant.price/variant.compare_at_price)*100);saveEl.textContent=`-${pct}%`;saveEl.hidden=false}else saveEl.hidden=true;
      }
      if(addBtn){
        if(!variant.available){addBtn.disabled=true;addBtn.dataset.hcUnavailable='true';}
        else if(addBtn.dataset.hcUnavailable==='true'){addBtn.disabled=false;delete addBtn.dataset.hcUnavailable;}
        const label=addBtn.querySelector('[data-label]');if(label)label.textContent=variant.available?addBtn.dataset.label:addBtn.dataset.soldout;
      }
      if(stickyBtn) stickyBtn.disabled=!variant.available;
      if(stockEl){stockEl.classList.toggle('is-unavailable',!variant.available);const span=stockEl.querySelector('span');if(span)span.textContent=variant.available?'Em estoque':'Indisponível';}
      if(variant.featured_media) setActiveMedia(variant.featured_media.id,null,true);
      const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
    }

    root.querySelectorAll('[data-hc-option-group] input').forEach(input=>input.addEventListener('change',syncVariant));
    thumbs.forEach(thumb=>thumb.addEventListener('click',()=>setActiveMedia(thumb.dataset.mediaId,thumb.dataset.index,true)));

    if(stage&&slides.length>1){
      stage.addEventListener('scroll',()=>{
        if(!isMobile()) return;
        clearTimeout(scrollTimer);
        scrollTimer=setTimeout(()=>{
          const center=stage.scrollLeft+(stage.clientWidth/2);
          let closest=slides[0],distance=Infinity;
          slides.forEach(slide=>{const c=slide.offsetLeft+(slide.offsetWidth/2);const d=Math.abs(c-center);if(d<distance){distance=d;closest=slide;}});
          setActiveMedia(closest.dataset.mediaId,closest.dataset.index,false);
        },70);
      },{passive:true});
    }

    const zoom=root.querySelector('[data-hc-zoom-dialog]');
    const zoomImage=root.querySelector('[data-hc-zoom-image]');
    const zoomClose=root.querySelector('[data-hc-zoom-close]');
    function openZoom(slide){
      const img=slide&&slide.querySelector('img');if(!zoom||!zoomImage||!img)return;
      zoomImage.src=img.currentSrc||img.src;zoomImage.srcset=img.srcset||'';zoom.classList.add('is-open');zoom.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';
    }
    function closeZoom(){if(!zoom)return;zoom.classList.remove('is-open');zoom.setAttribute('aria-hidden','true');document.documentElement.style.overflow='';}
    slides.forEach(slide=>slide.addEventListener('click',e=>{if(Math.abs(stage?.scrollLeft||0)%Math.max(stage?.clientWidth||1,1)<4||!isMobile())openZoom(slide)}));
    if(zoomClose)zoomClose.addEventListener('click',closeZoom);
    if(zoom)zoom.addEventListener('click',e=>{if(e.target===zoom)closeZoom()});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&zoom?.classList.contains('is-open'))closeZoom()});

    syncVariant();

    if(sticky&&addBtn){
      const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{const show=!entry.isIntersecting&&entry.boundingClientRect.top<0;sticky.classList.toggle('is-visible',show);document.body.classList.toggle('hc-has-sticky',show);});},{threshold:.08});
      observer.observe(addBtn);
      if(stickyBtn)stickyBtn.addEventListener('click',()=>{if(!stickyBtn.disabled&&!addBtn.disabled)addBtn.click()});
    }
  });

  document.querySelectorAll('[data-hc-faq]').forEach(wrap=>{
    wrap.querySelectorAll('details').forEach(detail=>detail.addEventListener('toggle',()=>{if(detail.open)wrap.querySelectorAll('details').forEach(other=>{if(other!==detail)other.removeAttribute('open')})}));
  });
})();


(function(){
  function applyDeliveryLocation(city, regionCode){
    var els=document.querySelectorAll('[data-hc-delivery-location]');
    if(!els.length) return;
    var place='';
    if(city && regionCode){ place=city+', '+regionCode; }
    else if(city){ place=city; }
    else if(regionCode){ place=regionCode; }
    if(!place) return;
    els.forEach(function(el){ el.textContent='Envio de 2 a 5 dias para '+place+' e Região'; });
  }
  function fallback(){
    document.querySelectorAll('[data-hc-delivery-location]').forEach(function(el){
      var f=el.getAttribute('data-fallback');
      if(f) el.textContent=f;
    });
  }
  function loadLocation(){
    var els=document.querySelectorAll('[data-hc-delivery-location]');
    if(!els.length) return;
    try{
      var cached=JSON.parse(localStorage.getItem('hc_delivery_geo')||'null');
      if(cached && cached.city && cached.region && cached.ts && (Date.now()-cached.ts<86400000)){
        applyDeliveryLocation(cached.city,cached.region);
        return;
      }
    }catch(e){}
    var controller=window.AbortController?new AbortController():null;
    var timer=setTimeout(function(){ if(controller) controller.abort(); fallback(); },3500);
    fetch('https://ipwho.is/?fields=success,city,region_code,country_code',{signal:controller?controller.signal:undefined,cache:'no-store'})
      .then(function(r){ if(!r.ok) throw new Error('geo'); return r.json(); })
      .then(function(d){
        clearTimeout(timer);
        if(d && d.success!==false && d.country_code==='BR' && (d.city||d.region_code)){
          applyDeliveryLocation(d.city,d.region_code);
          try{ localStorage.setItem('hc_delivery_geo',JSON.stringify({city:d.city||'',region:d.region_code||'',ts:Date.now()})); }catch(e){}
        }else{ fallback(); }
      })
      .catch(function(){ clearTimeout(timer); fallback(); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',loadLocation); else loadLocation();
})();
